// <VisuallyHidden> — visually hidden but screen-reader visible.
//
// Closes TP-1 / TP-11 from
// design/30-engineering/ui-implementation/_fix-up-pass-1.md §2.
//
// Implementation: structural-zero size + clip-path inset(50%) per the WAI
// "screen reader only" recipe and DESIGN_POLICY.md §5 non-color cue rule.
// Token: tokens.visuallyHidden.size = 1 px.

import type { CSSProperties, ReactNode } from 'react';
import { tokens } from '../tokens';

export interface VisuallyHiddenProps {
  children: ReactNode;
  /** Render as inline (`<span>`) or block (`<div>`); default 'span'. */
  as?: 'span' | 'div';
  'data-testid'?: string;
  /** Optional id (consumed by `aria-describedby`/`aria-labelledby`). */
  id?: string;
}

export function VisuallyHidden({
  children,
  as = 'span',
  id,
  'data-testid': testId,
}: VisuallyHiddenProps) {
  const Tag = as as 'span';
  const style: CSSProperties = {
    position: 'absolute',
    width: tokens.visuallyHidden.size,
    height: tokens.visuallyHidden.size,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    border: 0,
    padding: 0,
    margin: -tokens.visuallyHidden.size,
  };
  return (
    <Tag id={id} data-testid={testId} style={style}>
      {children}
    </Tag>
  );
}
